import { render } from "./RecentSalesCard.vue?vue&type=template&id=41bae5a7"
import script from "./RecentSalesCard.vue?vue&type=script&lang=js"
export * from "./RecentSalesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__